import BaseService from "@/boot/BaseService";
class HelperListService extends BaseService {
  constructor() {
    super(null, "/helper-list");
  }
  async grupoProductosWeb() {
    return await this.get("/grupo-productos-web");
  }

}

export default new HelperListService();
